.card {
  display: flex;
}

.image {
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  aspect-ratio: 1;
  margin-bottom: 16px;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--border-radius-sm);
}

.badges {
  position: absolute;
  right: 8px;
  top: 8px;
}

.categoryLabel {
  padding: 0;

  @media (--reefer-media-desktop-sm-max) {
    /* Make up for smaller line heights on mobile */
    padding: 4px 0;
  }
}

.bullets {
  list-style: none;
  margin: 0;
  padding: 0;
}
